module.exports = "/img/item-7.26a2b0f0.png";